// By default, this pack is loaded for server-side rendering.
// It must expose react_ujs as `ReactRailsUJS` and prepare a require context.
const ServerRendering = () => {
  var componentRequireContext = require.context('components', true)
  var ReactRailsUJS = require('react_ujs') // eslint-disable-line
  ReactRailsUJS.useContext(componentRequireContext)
}

ServerRendering()
